export default "__VITE_ASSET__DvjcG4FR__"